import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterContentInit, AfterViewInit, Component, HostListener, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PRM } from '@reflact/prmacweb';
import { QuillEditorComponent } from 'ngx-quill';
import { AuthService } from '../../auth/auth.service';
import { HeightWatcherDirective } from '../../height-watcher.directive';
import { SecurePipe } from '../../pipes/secure.pipe';
import { KONVA_VIEW_TYPE_DRAW, KONVA_VIEW_TYPE_PREVIEW, KonvaCanvasComponent } from '../konva-canvas/konva-canvas.component';
import { KonvaPaintboxComponent } from '../konva-canvas/konva-paintbox/konva-paintbox.component';
import { PageContext } from '../resolver/PageAnnotationResolver';
import { RiButtonComponent } from '../ri-button/ri-button.component';
import { PdfAnnotationService } from '../services/PdfAnnotationService';
import { LayoutDirective } from '../services/layout.directive';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: 'app-document-content-renderer-single-doc',
  templateUrl: './document-content-renderer-single-docold.component.html',
  styleUrls: ['./document-content-renderer-single-docold.component.css'],
  imports: [
    CommonModule,
    HeightWatcherDirective,
    KonvaCanvasComponent,
    KonvaPaintboxComponent,
    LayoutDirective,
    RiButtonComponent,
    FormsModule,
    QuillEditorComponent,
    SecurePipe
  ],
  standalone: true
})
export class DocumentContentRendererSingleDocoldComponent implements AfterViewInit, AfterContentInit {

  public pagesNeededToScreenshot = [];
  public debugMSG = "";
  public loadedThumbCounter = 0;
  public proceededImageCount = 0;
  public requredShots = 0;
  public _currentPage: number = 0;
  public selectedDocObject: PRM.Document;
  public editAreaVisible = false;
  public pageContexts: PageContext[] = [];
  public bindedAnnotations: string[] = [''];
  public debufStoreMap: Map<string, string> = new Map<string, string>();
  public debufInterval: any;
  public konvaJsons: object[] = [];
  public myUser: PRM.Observer | PRM.Participant;
  public docZoom: number = 90;
  public docIsReady = false;



  // ZOOM
  private lastCenter: any = false;
  private halfScreenHeight = 0;
  private lastDist: any = false;
  private zoomByTouch = false;
  public lastEmitTimestamp: number = 0;
  public storedDifferece = 0;
  public isInLoadingState = false;
  public startTouchX = 0;
  public startTouchY = 0;
  public storedScrollTop = 0;
  public storedAllPagesWrapperHeight = 0;
  public newMagicNumber = 0;

  public zoomStep = 5;
  public minzoom = 30;
  public maxzoom = 90;
  @ViewChildren(KonvaCanvasComponent) allCanvas: QueryList<KonvaCanvasComponent> = new QueryList<KonvaCanvasComponent>();
  public _allCanvas: QueryList<KonvaCanvasComponent> = new QueryList<KonvaCanvasComponent>();
  constructor(
    public scroller: ViewportScroller,
    public aRoute: ActivatedRoute,
    public router: Router,
    public layoutService: LayoutService,
    public authService: AuthService,
    public annotationService: PdfAnnotationService
  ) {
    if (this.isIpad()) { this.maxzoom = 90; }
    aRoute.data.subscribe((data) => {
      console.log(data);
      this.konvaJsons = data.pack.konvaJsons;
      console.log("konvaJsons", this.konvaJsons);
      this.konvaJsons.forEach((konvaJson, index) => {
        if (Object.keys(konvaJson).length > 0) {
          this.pagesNeededToScreenshot.push(index);
        }
      });
      this.requredShots = this.pagesNeededToScreenshot.length;
      this.selectedDocObject = data.pack.selectedDocObject;
      this.pageContexts = data.pack.pageContexts;
      this.bindedAnnotations = data.pack.annotations;
      this.myUser = data.pack.pack.me;
    });
  }

  isIpad() {
    return navigator.maxTouchPoints == 5;
  }


  ngAfterContentInit(): void {
    this._allCanvas = this.allCanvas;
  }

  ngAfterViewInit(): void {

    if (!this.selectedDocObject.metadata.editable) {
      this.allCanvas.forEach((k) => {
        k.pencilMode = false;
      })
    }
  }

  public getPagePreviewUrl(documentId, pageNo, timeblockId, participantId, watermark = false) {
    // DIESE URL IST FÜR KRITZELLEI UND WARTERMAR, THOMAS MACHT HIER ALLES AUF DEM SERVER
    let url = '/api/pagepreview/' + documentId + '/' + pageNo + '/';
    if (watermark) {
      // DIESE URL IST FÜR NUR DIE WATERMARK UND ____KEIN____ GEKRITZEL
      url = '/api/pagewatermark/' + documentId + '/' + pageNo + '/';
    }
    if (timeblockId) {
      url += timeblockId;
    } else {
      url += 'introduction';
    }
    url += '/'
    if (participantId) {
      url += participantId;
    } else {
      url += '-1';
    }
    return url;
  }

  /*  @HostListener('touchstart', ['$event'])
    handleTouchStart(event: TouchEvent): void {
      console.log(" event touchstart");
      if (event.touches.length == 2) {
        this.halfScreenHeight = window.innerHeight / 2;
        this.startTouchX = event.touches[0].clientX;
        this.startTouchY = event.touches[0].clientY;
        let scrollingElement = document.getElementById("scrollingTag");
        this.storedAllPagesWrapperHeight = document.getElementById("allPagesWrapper").offsetHeight;
        this.storedScrollTop = scrollingElement.scrollTop;
        let st = scrollingElement.scrollTop;
        this.newMagicNumber = (st + this.halfScreenHeight) / this.storedAllPagesWrapperHeight;
        // zoomToolActive zeigt den Screenshot
        /*       this.allCanvas.forEach((k) => {
                k.forceSnapshot = true;
              })
}
  } */

  // TUT NIX AUSSER MAN HALTET DEN FINGER AUF DEM SCREEN
  @HostListener('touchmove', ['$event'])
  handleTouchMove(event: TouchEvent): void {
    if (this.getIsLoading()) { return; }
    if (event.touches.length == 2) {
      this.zoomByTouch = true;
      this.allCanvas.forEach((k) => {
        k.setViewType(KONVA_VIEW_TYPE_PREVIEW);
      })
      this.handleZoom(event);
    }
  }

  @HostListener('touchend', ['$event'])
  handleTouchEnd(event: TouchEvent): void {
    this.lastDist = null;
    if (this.zoomByTouch) {
      this.zoomByTouch = false;
      this.allCanvas.forEach((k) => {
        k.invalidateView(this._currentPage)
      })

    }
  }

  public getIsLoading() {
    return this.pageContexts.length != this.loadedThumbCounter;
  }

  public changePencilMode(e) {
    this.allCanvas.forEach(k => {
      k.pencilMode = e;
    });
  }


  public onImageProceeded(e) {
    this.proceededImageCount++;
  }

  public selectPage = (page: number) => {
    this._currentPage = page;
    this.allCanvas.forEach(k => {
      if (k.pageContext.page == page) {
        k.setViewType(KONVA_VIEW_TYPE_DRAW);
      } else {
        k.setViewType(KONVA_VIEW_TYPE_PREVIEW);
      }
    }
    );
  }

  public getSelectedCanvas() {
    if (this.allCanvas) {
      return this.allCanvas.get(0)
    } else {
      return undefined;
    }
  }

  public scrollTo(tagId: number) {
    if (tagId < 0) {
      return;
    }
    if (this.selectedDocObject.metadata.pagescount <= tagId) {
      return;
    }

    this.selectPage(tagId);
    document.getElementById('page_' + tagId).scrollIntoView({
      behavior: "auto",
      block: "start",
      inline: "nearest"
    });
    document.getElementById("headernavbar").style.display = "none";

    setTimeout(() => {
      document.getElementById("headernavbar").style.display = "flex";
    }, 1)
  }

  getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
  }

  getCenter(p1, p2) {
    return {
      x: (p1.x + p2.x) / 2,
      y: (p1.y + p2.y) / 2,
    };
  }

  handleZoom(e) {
    let touch1 = e.touches[0];
    let touch2 = e.touches[1];
    if (touch1 && touch2) {
      let p1 = { x: touch1.clientX, y: touch1.clientY };
      let p2 = { x: touch2.clientX, y: touch2.clientY };
      if (!this.lastCenter) {
        this.lastCenter = this.getCenter(p1, p2);
        return;
      }
      let newCenter = this.getCenter(p1, p2);
      let dist = this.getDistance(p1, p2);
      if (!this.lastDist) { this.lastDist = dist; }
      let difference = (this.lastDist - dist);
      this.lastDist = dist;
      this.lastCenter = newCenter;
      this.emitWithDelay(difference);
    }
  }

  emitWithDelay(difference: number): void {
    this.storedDifferece += difference;

    this.onZoomChanged(this.storedDifferece);
    const now = Date.now();
    const timeDifference = now - this.lastEmitTimestamp;
    if (timeDifference >= 20) { // Check if at least 2 seconds have passed
      this.onZoomChanged(this.storedDifferece);
      this.storedDifferece = 0;
      this.lastEmitTimestamp = now; // Update the timestamp of the last emit
    }
  }

  public closeEditor() {


    const targetUrl = this.router.url.split('/docs')[0] + '/docs';
    this.router.navigateByUrl(targetUrl);
  }

  public onBlur() {
    clearInterval(this.debufInterval);
    this.storeDebuffed();
  }

  /** macht irgendwas um die anotations unten rein zu schreiben */
  public cbtest(str) {
    clearInterval(this.debufInterval);
    this.bindedAnnotations[this._currentPage] = str;
    this.debufStoreMap.set(JSON.stringify(this.pageContexts[this._currentPage]), str);
    this.debufInterval = setTimeout(this.storeDebuffed.bind(this), 2000);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    console.log(" event window:resize");
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    this.allCanvas.forEach((k) => {
      k.setViewType('KONVA_VIEW_TYPE_PREVIEW');
    });
    console.log("window:orientationchange");
  }

  public getContentAreaHeight() {
    return window.innerHeight - this.layoutService.headerHeightInt;
  }
  public getContentAreaWidth() {
    return window.innerWidth;
  }

  public getContentAreaOrientation(): 'landscape' | 'portrait' {
    if (this.getContentAreaWidth() > this.getContentAreaHeight()) {
      return 'landscape';
    }
    return 'portrait';
  }


  public snapshotPage(index) {
    //    alert(index);
    // this.allCanvas.toArray()[index].updateMySnapshots();

  }


  public setAllStagesToWidth(width: number) {
    this.allCanvas.forEach((k) => {
      k.setViewType('KONVA_VIEW_TYPE_PREVIEW');

      k.setStageWidth(width);
    });
  }

  public invalidateAllStageViews() {
    console.log("invalidateAllStageViews");
    this.allCanvas.forEach((k) => {
      k.invalidateView(this._currentPage);
    });

  }





  public zoomOut() {
    if (this.docZoom <= this.minzoom) { return }
    this.docZoom -= this.zoomStep;
    //
    this.allCanvas.forEach((k) => {
      k.setViewType('KONVA_VIEW_TYPE_PREVIEW');
    });
    this.docZoom = Math.max(this.minzoom, this.docZoom);
    document.getElementById("touchMarker").style.width = this.docZoom + "%";
    document.getElementById("allPagesWrapper").style.width = this.docZoom + "%";
  }

  public zoomIn() {
    if (this.docZoom >= this.maxzoom) { return }
    this.docZoom += this.zoomStep;
    this.allCanvas.forEach((k) => {
      k.setViewType('KONVA_VIEW_TYPE_PREVIEW');
    });
    this.docZoom = Math.min(this.maxzoom, this.docZoom);
    document.getElementById("touchMarker").style.width = this.docZoom + "%";
    document.getElementById("allPagesWrapper").style.width = this.docZoom + "%";
  }

  public zoomTo(newZoom) {
    this.docZoom = newZoom;
    this.docZoom = Math.min(this.maxzoom, this.docZoom);
    document.getElementById("touchMarker").style.width = this.docZoom + "%";
    document.getElementById("allPagesWrapper").style.width = this.docZoom + "%";
  }

  // !!! DIE SEITEN ÜBERSCHRIFTEN IMMER SO WEIT WIE DER TOUCHMARKER IST
  public onZoomChanged(differencePX: number) {
    // !!! NEUE BREITE AUSRECHNEN UND CHECKEN OB SIE ZU BREIT
    // !!! ODER ZU KLEIN WIRD
    // TOUCH MARKER BREITE IN PX
    let currentWidtPX = document.getElementById("touchMarker").offsetWidth;
    const tmPercentageWidthStr = document.getElementById("touchMarker").style.width;
    let tmPercentageWidthNumber = parseInt(tmPercentageWidthStr.split("%")[0]);
    let newWidthPX = (currentWidtPX - differencePX);
    let percentageGrowth = (newWidthPX / currentWidtPX);
    let newWPercentage = tmPercentageWidthNumber * (percentageGrowth);
    newWPercentage = Math.min(this.maxzoom, newWPercentage);
    newWPercentage = Math.max(this.minzoom, newWPercentage);
    this.docZoom = newWPercentage;
    document.getElementById("touchMarker").style.width = newWPercentage + "%";
    document.getElementById("allPagesWrapper").style.width = newWPercentage + "%";
    let scrollingElement = document.getElementById("scrollingTag");
    this.storedAllPagesWrapperHeight = document.getElementById("allPagesWrapper").offsetHeight;

    let wrapperHeight = this.storedAllPagesWrapperHeight
    let newSt = this.newMagicNumber * wrapperHeight - this.halfScreenHeight;
    scrollingElement.scrollTop = newSt;
  }

  public thumbLoaded(i: number) {
    // VON KLEINES BILD NACH GRO?ES BILD NUR DANN WENN ICH NOCH IN DER PRELOADING PHASE BIN
    if (this.loadedThumbCounter < this.pageContexts.length) {
      console.log("leoade thumb and set big image", i)
      // SET THE LARGE IMAGE EQUALS THE THUMB;
      let thumburl = document.getElementById(this.selectedDocObject._id + "_" + i).getAttribute("src");
      let bg = "konva_large_image_" + i;
      document.getElementById(bg).setAttribute("src", thumburl);
      this.loadedThumbCounter++;
    }
  }



  public storeDebuffed() {
    this.debufStoreMap.forEach((value, pageContextStr, map) => {
      const pageContext: PageContext = JSON.parse(pageContextStr);
      this.annotationService.storeAnnotationText(
        pageContext.docid,
        pageContext.page,
        pageContext.timeblockid,
        pageContext.participantid,
        value
      );
    });
    this.debufStoreMap.clear();
  }

  counter(i: number) {
    return new Array(i);
  }

  public getRouterLinkForPageSwitch(page: number, userid) {
    if (page >= this.selectedDocObject.metadata.pagescount || page < 0) {
      return [];
    }
    if (userid !== undefined) {
      return ['../../', page, userid];
    } else {
      return ['../', page];
    }
  }
}
